export const renderCardNumber = (maskedPan = '', withDots = false): string => {
  if (withDots) {
    return `••• ${maskedPan}`
  }

  return maskedPan
}
